import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import { __t } from '@mssgme/shared';
import { FormField } from '@mssgme/ui';
import { useInputTheme, useCustomInputTheme } from '../../../hooks';

import styles from './TextField.scss';

const propTypes = {
    ...FormField.propTypes,
    theme: PropTypes.object,
    name: PropTypes.string.isRequired,
};

export function TextField({ theme, ...props }) {
    const defaultStyle = useInputTheme(theme);
    const customStyle = useCustomInputTheme(theme);
    const [field, meta] = useField(props);
    const style = customStyle || defaultStyle;

    return (
        <FormField
            shakeError
            type="text"
            errors={meta.touched && meta.error}
            label={props.label ? null : __t(props.name)}
            style={style.input}
            errorStyle={style.error}
            inputClassName={styles.input}
            labelClassName={styles.label}
            {...field}
            {...props}
        />
    );
}

TextField.propTypes = propTypes;
